import {handleResponseError} from './handleResponseError';

export const handleResponse = async (response: Response) => {
    if (!response.ok) {
        await handleResponseError(response);
    }

    return response.json();
};
